<template>
  <v-container>
    <h1>{{ $t('labels.workplaces') }}</h1>
    <p>{{ $t('company.workplaces.p1') }}</p>

    <workplaces-list
      :tabId="getTabId"
      :isDepartments="hasDepartments($route.params.id)"
      :workplaces="workplaces"
      @item-click="workplaceClick"
      actionType="view"
      withSearch
      withExplanation
      :searchText="$route.params.search"
    >
      <template v-slot:custom-text="slotProps"> ({{ slotProps.numApprenticeships }})</template>
    </workplaces-list>
    <v-btn
      v-if="isAdminRole"
      fixed
      fab
      bottom
      right
      class="elevation"
      color="primary"
      :disabled="isImitatingUser()"
      @click="
        $nextTick(() => {
          $router.push({name: 'CompanyWorkplace', params: {id: $route.params.id, workplace_id: 'new'}})
        })
      "
    >
      <v-icon>$sl-add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import API from '@/services/api.js'
import {CompanyRoles} from '@/components/mixins'
import {mapGetters} from 'vuex'
import find from 'lodash/find'
import filter from 'lodash/filter'
import concat from 'lodash/concat'
import uniq from 'lodash/uniq'
import WorkplacesList from '@/components/Common/Workplace/WorkplacesList'

// @group Application-Company
// CompanyWorkplaces component
export default {
  name: 'CompanyWorkplaces',

  mixins: [CompanyRoles],

  components: {
    WorkplacesList
  },
  data: () => ({
    workplaces: [],
    fetched: false
  }),

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isAdministrator', 'isDepartmentAdministrator', 'isImitatingUser']),

    getTabId() {
      if (this.$route && this.$route.params && this.$route.params.tab) {
        return this.$route.params.tab
      }
    },

    isAdminRole() {
      return this.isAdministrator || this.isDepartmentAdministrator
    }
  },

  created() {
    this.init()
  },

  methods: {
    /**
     * @vuese
     * Used to fetch workplace
     * @arg The argument is an integer value representing workplace id
     */
    init() {
      API.getWorkplaces(this.$route.params.id).then(result => {        
        let wpArray = []
        let noDep = []
        if (this.hasDepartments(this.$route.params.id)) {
          result.data.forEach(w => {
            if (w.departmentIds.length > 0) {
              w.departmentIds.forEach(depId => {
                if (this.isAdministrator) {
                  wpArray.push(w)
                } else {
                  let found = this.getCurrentUserDepartmentsIds(this.$route.params.id).find(x => x == depId)

                  if (found) {
                    wpArray.push(w)
                  }
                }
              })
            } else {
              let noDepObj=w
              w.departmentWorkplaces.push({
                departmentId:-1,
                department: {
                  description: "",
                  id: -1,
                  name: this.$t('company.missing-department'),
                }
              })
              noDep.push(w)
            }            
            
            this.workplaces = concat(uniq(wpArray, 'id'), uniq(noDep, 'id'))
            //ret.this.getCurrentUserDepartmentsIds(this.$route.params.id).filter(x=>x == did)
          })
        }
        else {
          this.workplaces=result.data
        }
      })
    },
    workplaceClick(workplace) {
      //console.log("wpclicked::", workplace)
      let tab = 0
      if (workplace.tab) {
        tab = workplace.tab
      }
      this.$nextTick(() => {
        this.$router.push({
          name: 'CompanyWorkplace',
          params: {
            id: this.$route.params.id,
            workplace_id: workplace.id ? workplace.id : 0,
            tab: tab
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>